// import React, { useState, useRef, useEffect } from "react";
// import "./paidmodal.css";
// import { IoAddSharp, IoClose } from "react-icons/io5";
// import { IoCloseCircleOutline } from "react-icons/io5";
// import { useUser } from "../../../Utility/UserProvider";
// import APICall from "../../../Utility/APICall";
// import { paths } from "../../../Utility/Constants";
// import { useAuth } from "../../../Utility/AuthProvider";
// import { cloudStorageBucket } from "../../../Utility/Constants";
// import { GetUploadMediaBaseLocation } from "../../../Utility/APICall";
// import { getDownloadURL } from "firebase/storage";
// import FileUpload from "../../../Utility/FileUpload";
// import FileDownload from "../../../Utility/FileDownload";
// // import {storage} from '../../Utility/firebase'
// import { storage } from "../../../Utility/firebase";
// import { ref, uploadBytesResumable } from "firebase/storage";

// const PaidModal = ({
//   onClose,
//   onMarkAsPaid,
//   selectedTenant,
//   setSelectedPaymentType,
//   setSelectedFile,
// }) => {
//   const { jwt, user } = useAuth();
//   // const { user } = useUser();
//   const fileInputRef = useRef(null);

//   const [formData, setFormData] = useState({
//     paymentMethod: "", // Selected payment method
//     description: "", // Payment description
//     // file: [], // Uploaded file
//   });

//   const [isLoading, setIsLoading] = useState(false);
//   const [imagePreview, setImagePreview] = useState(null);
//   // const [imageFiles, setImageFiles] = []
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [file, setFile] = useState([]);
//   const [downloadURL, setDownloadURL] = useState("");
//   const [description, setDescription] = useState("");
//   const [transcationID, setTransactionID] = useState(null);

//   const [imageDimensions, setImageDimensions] = useState({
//     height: 0,
//     width: 0,
//   });

//   // const handleFileUpload = (file) => {
//   //   setFile(file);s
//   // };

//   useEffect(() => {
//     const fetchTransactionData = async () => {
//       try {
//         const response = await APICall(
//           "GET",
//           paths.transaction.fetch,
//           undefined,
//           {
//             unit_id: selectedTenant.unit_id,
//           },
//           jwt
//         );
//         console.log("USER DATA FROM AUTH CONTEXT", user);
//         console.log("Response Tansaction Fetch:", response);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchTransactionData();
//   }, [jwt]);

//   const handleAddTransactionWithoutMediaToDatastore = async () => {
//     const body = {
//       paymentMethod: formData.paymentMethod, // Updated to reflect payment method
//       description: formData.description, // Added description field
//       status: "active",
//     };

//     try {
//       setIsLoading(true);
//       const res = await APICall(
//         "POST",
//         paths.transaction.add,
//         body,
//         undefined,
//         jwt
//       );

//       if (res.status === "success") {
//         setIsLoading(false);
//         setFormData({
//           paymentMethod: "",
//           description: "",
//           file: null,
//         });
//         setTransactionID(res.entity_id);
//         alert("Payment marked as successful!");
//         return res.response.entity_id;
//       } else {
//         console.error("Error in marking payment as successful");
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleAddMediaToTransactionToDatastore = async (
//     building_id,
//     downloadURL
//   ) => {
//     try {
//       const media = {
//         name: formData.file.name,
//         location: downloadURL, // Use Firebase-generated download URL
//         type: formData.file.type,
//         size: formData.file.size,
//       };

//       const body = {
//         building_id: building_id,
//         media: JSON.stringify(media),
//       };

//       const response = await APICall(
//         "PUT",
//         paths.transaction.update,
//         body,
//         undefined,
//         jwt
//       );
//       console.log(response);

//       alert("Media added successfully");
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleAddMediaWithFirebaseStorageUpload = async (
//     transactionId,
//     fileName
//   ) => {
//     try {
//       // const building_id = await handleAddTransactionWithoutMediaToDatastore();
//       const baseUploadLocation = GetUploadMediaBaseLocation(
//         cloudStorageBucket.transaction,
//         user
//       );
//       const location = `${baseUploadLocation}${transactionId}/${fileName}`;
//       const reference = ref(storage, location);
//       const uploadTask = uploadBytesResumable(reference, file);

//       uploadTask.on(
//         "state_changed",
//         (snapshot) => {
//           const progress =
//             (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//           console.log(`Upload is ${progress}% done`);
//         },
//         (error) => {
//           console.error("Upload failed", error);
//         },
//         async () => {
//           const downloadURL = await getDownloadURL(uploadTask.snapshot.ref); // Corrected usage
//           console.log("Download URL:", downloadURL);
//           await handleAddMediaToTransactionToDatastore(
//             transactionId,
//             downloadURL
//           );
//         }
//       );
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleImageLoad = (e) => {
//     const { naturalHeight, naturalWidth } = e.target;
//     setImageDimensions({ height: naturalHeight, width: naturalWidth });
//   };

//   const handleFileChange = (event) => {
//     // let files = []

//     console.log("event.target.files --- ", event.target.files);

//     const selectedFile = event.target.files[0];

//     setFile([...file, selectedFile]);

//     // setImageFiles({...imageFiles, imageFiles})

//     const acceptedFormats = ["image/jpeg", "image/png"];

//     if (selectedFile && acceptedFormats.includes(selectedFile.type)) {
//       setFormData((prev) => ({ ...prev, file: selectedFile }));
//       setImagePreview(URL.createObjectURL(selectedFile));
//     } else {
//       alert("Please select a valid file format (JPG or PNG).");
//     }
//   };

//   const handlePaymentMethodChange = (method) => {
//     setSelectedPaymentType(method);
//     setSelectedPaymentMethod(method);
//     setFormData((prev) => ({ ...prev, paymentMethod: method }));
//   };

//   const handleClearFile = () => {
//     setFormData((prev) => ({ ...prev, file: null }));
//     setImagePreview(null);
//   };

//   const handleSubmit = async () => {
//     const { paymentMethod, description } = formData;

//     const handleFirebaseStorageUpload = async (transactionID) => {
//       try {
//         const fileLocations = await Promise.all(
//           file.map(async (item) => {
//             const baseUploadLocation = GetUploadMediaBaseLocation(
//               cloudStorageBucket.transaction,
//               user
//             );
//             const location = `${baseUploadLocation}${transactionID}/${item.name}`;

//             console.log("🥸 Uploading to location: ", location);

//             const reference = ref(storage, location);
//             // const task = reference.putFile(item.path);
//             // Start the upload
//             const task = uploadBytesResumable(reference, item);

//             // Wait for upload task completion
//             await new Promise((resolve, reject) => {
//               task.on(
//                 "state_changed",
//                 (snapshot) => {
//                   console.log(
//                     `${snapshot.bytesTransferred} bytes transferred out of ${snapshot.totalBytes}`
//                   );
//                 },
//                 reject, // Handle error
//                 resolve // On success
//               );
//             });

//             return location; // Return the location for the current file
//           })
//         );

//         console.log("Uploaded file locations: ", fileLocations);
//         return fileLocations;
//       } catch (error) {
//         console.error("‼️ Error during file upload: ", error);
//         throw new Error("File upload failed");
//       }
//     };

//     if (!paymentMethod) {
//       alert("Please select a payment method.");
//       return;
//     }

//     try {
//       setIsLoading(true);

//       // Step 1: Upload files (if any)
//       let fileLocations = [];
//       if (file.length > 0) {
//         const transactionID = transcationID; // Fetch transaction ID first
//         fileLocations = await handleFirebaseStorageUpload(transactionID);
//       }

//       // Step 2: Prepare media array
//       const media = file.map((item, index) => ({
//         name: item.name,
//         location: fileLocations[index], // Associate correct location
//         type: item.type,
//         height: imageDimensions.height,
//         width: imageDimensions.width,
//         size: item.size,
//         description: "", // Add descriptions if needed
//       }));

//       // Step 3: Prepare payload
//       const body = {
//         description,
//         media: media.length > 0 ? JSON.stringify(media) : null,
//         tenant_name: selectedTenant.tenant_name,
//         building_name: selectedTenant.building_name,
//         unit_name: selectedTenant.unit_name,
//         agreement_id: selectedTenant.agreement_id,
//         building_id: selectedTenant.building_id,
//         unit_id: selectedTenant.unit_id,
//         year: selectedTenant.year,
//         nature: selectedTenant.nature,
//         type: selectedTenant.type,
//         payment_status: "success",
//         payment_mode: selectedPaymentMethod,
//         payment_id: selectedPaymentMethod.split("-")[0],
//         amount: selectedTenant.amount,
//         month: selectedTenant.month,
//       };

//       console.log("Payload body: ", body);

//       // Step 4: Make API call to save transaction
//       const response = await APICall(
//         "POST",
//         paths.transaction.add,
//         body,
//         null,
//         jwt
//       );

//       console.log("API Response: ", response);

//       if (response.status === "success") {
//         alert("Payment marked as successful!");
//         onMarkAsPaid();
//         onClose();
//       } else {
//         console.error("Error submitting payment", response);
//       }
//     } catch (error) {
//       console.error("Error during submission: ", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const paymentMethods = [
//     "manual-UPI",
//     "manual-Cash",
//     "manual-Cheque",
//     "manual-NEFT",
//     "manual-Others",
//   ];

//   return (
//     <div className="modal-overlay">
//       <div className="modal">
//         <IoCloseCircleOutline style={{ float: "right" }} onClick={onClose} />
//         <div className="modal-content">
//           <h2 style={{ fontSize: "30px", textAlign: "center" }}>
//             Mark as Paid
//           </h2>
//           <div className="payment-methods">
//             <h3 className="pt-2 text-center">Select Payment Method</h3>
//             <div id="payment-type-container">
//               {paymentMethods.map((method) => (
//                 <button
//                   key={method}
//                   type="button"
//                   onClick={() => handlePaymentMethodChange(method)}
//                   style={{
//                     border: "1px solid #000",
//                     padding: "10px 20px",
//                     cursor: "pointer",
//                     background:
//                       formData.paymentMethod === method ? "blue" : "#fff",
//                     color: formData.paymentMethod === method ? "#fff" : "#000",
//                     borderRadius: "5px",
//                     outline: "none",
//                     margin: "5px",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {method.split("-")[1]}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div className="description-section">
//             <h3 className="p-4 text-center text-blue">+Add Description</h3>
//             <input
//               type="text"
//               value={formData.description}
//               onChange={(e) =>
//                 setFormData((prev) => ({
//                   ...prev,
//                   description: e.target.value,
//                 }))
//               }
//               placeholder="Add your description here..."
//               style={{
//                 width: "100%",
//                 padding: "10px",
//                 border: "1px solid #000",
//                 borderRadius: "5px",
//               }}
//             />
//           </div>
//           <div className="file-input-container">
//             {!formData.file && (
//               <div onClick={() => fileInputRef.current.click()}>
//                 <IoAddSharp />
//                 <p>Upload Receipt</p>
//                 <p>Supported files: PNG, JPG</p>
//               </div>
//             )}
//             <input
//               type="file"
//               ref={fileInputRef}
//               multiple
//               onChange={handleFileChange}
//               style={{ display: "none" }}
//             />
//             {imagePreview && (
//               <div className="file-preview">
//                 <img
//                   src={imagePreview}
//                   alt="Preview"
//                   onLoad={handleImageLoad}
//                   style={{ maxWidth: "200px", maxHeight: "200px" }}
//                 />
//                 <IoClose className="clear-file" onClick={handleClearFile} />
//               </div>
//             )}
//           </div>
//           <button id="submit-paid" onClick={handleSubmit} disabled={isLoading}>
//             {isLoading ? "Submitting..." : "Submit Payment"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaidModal;

import React, { useState, useRef, useEffect } from "react";
import { IoAddSharp, IoClose } from "react-icons/io5";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useAuth } from "../../../Utility/AuthProvider";
import APICall from "../../../Utility/APICall";
import { paths } from "../../../Utility/Constants";
import { cloudStorageBucket } from "../../../Utility/Constants";
import { GetUploadMediaBaseLocation } from "../../../Utility/APICall";
import { getDownloadURL } from "firebase/storage";
import { storage } from "../../../Utility/firebase";
import { ref, uploadBytesResumable } from "firebase/storage";

const PaidModal = ({
  onClose,
  onMarkAsPaid,
  selectedTenant,
  setSelectedPaymentType,
  setSelectedFile,
}) => {
  const { jwt, user } = useAuth();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    paymentMethod: "",
    description: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [file, setFile] = useState([]);
  const [description, setDescription] = useState("");
  const [transcationID, setTransactionID] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({
    height: 0,
    width: 0,
  });

  // Debug: Log the selectedTenant data
  useEffect(() => {
    console.log("🐛 PaidModal: selectedTenant received:", selectedTenant);
    if (!selectedTenant) {
      console.error("❌ PaidModal: No selectedTenant data received!");
    }
  }, [selectedTenant]);

  useEffect(() => {
    const fetchTransactionData = async () => {
      if (!selectedTenant?.unit_id) {
        console.warn("⚠️ No unit_id available for transaction fetch");
        return;
      }

      try {
        const response = await APICall(
          "GET",
          paths.transaction.fetch,
          undefined,
          {
            unit_id: selectedTenant.unit_id,
          },
          jwt
        );
        console.log("📥 Transaction Fetch Response:", response);
      } catch (error) {
        console.error("❌ Error fetching transaction data:", error);
      }
    };

    if (selectedTenant) {
      fetchTransactionData();
    }
  }, [jwt, selectedTenant]);

  const handleImageLoad = (e) => {
    const { naturalHeight, naturalWidth } = e.target;
    setImageDimensions({ height: naturalHeight, width: naturalWidth });
  };

  const handleFileChange = (event) => {
    console.log("📁 File selected:", event.target.files);
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;

    setFile([...file, selectedFile]);

    const acceptedFormats = ["image/jpeg", "image/png", "image/jpg"];

    if (acceptedFormats.includes(selectedFile.type)) {
      setFormData((prev) => ({ ...prev, file: selectedFile }));
      setImagePreview(URL.createObjectURL(selectedFile));
    } else {
      alert("Please select a valid file format (JPG, JPEG, or PNG).");
    }
  };

  const handlePaymentMethodChange = (method) => {
    setSelectedPaymentType?.(method);
    setSelectedPaymentMethod(method);
    setFormData((prev) => ({ ...prev, paymentMethod: method }));
  };

  const handleClearFile = () => {
    setFormData((prev) => ({ ...prev, file: null }));
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    const { paymentMethod, description } = formData;

    if (!paymentMethod) {
      alert("Please select a payment method.");
      return;
    }

    if (!selectedTenant) {
      alert("No tenant data available. Please try again.");
      console.error("❌ No selectedTenant data available for submission");
      return;
    }

    const handleFirebaseStorageUpload = async (transactionID) => {
      try {
        const fileLocations = await Promise.all(
          file.map(async (item) => {
            const baseUploadLocation = GetUploadMediaBaseLocation(
              cloudStorageBucket.transaction,
              user
            );
            const location = `${baseUploadLocation}${transactionID}/${item.name}`;

            console.log("🔄 Uploading to location:", location);

            const reference = ref(storage, location);
            const task = uploadBytesResumable(reference, item);

            await new Promise((resolve, reject) => {
              task.on(
                "state_changed",
                (snapshot) => {
                  console.log(
                    `📊 Upload progress: ${snapshot.bytesTransferred}/${snapshot.totalBytes}`
                  );
                },
                reject,
                resolve
              );
            });

            return location;
          })
        );

        console.log("✅ Uploaded file locations:", fileLocations);
        return fileLocations;
      } catch (error) {
        console.error("❌ Error during file upload:", error);
        throw new Error("File upload failed");
      }
    };

    try {
      setIsLoading(true);

      // Step 1: Upload files (if any)
      let fileLocations = [];
      if (file.length > 0) {
        const transactionID = transcationID;
        fileLocations = await handleFirebaseStorageUpload(transactionID);
      }

      // Step 2: Prepare media array
      const media = file.map((item, index) => ({
        name: item.name,
        location: fileLocations[index],
        type: item.type,
        height: imageDimensions.height,
        width: imageDimensions.width,
        size: item.size,
        description: "",
      }));

      // Step 3: Construct tenant name properly
      const tenantName =
        selectedTenant.first_name && selectedTenant.last_name
          ? `${selectedTenant.first_name} ${selectedTenant.last_name}`
          : selectedTenant.tenant_name || "Unknown Tenant";

      // Step 4: Prepare payload with correct property mapping
      const body = {
        description: description || formData.description,
        media: media.length > 0 ? JSON.stringify(media) : null,
        tenant_name: tenantName,
        building_name: selectedTenant.building_name,
        unit_name: selectedTenant.unit_name,
        agreement_id: selectedTenant.agreement_id,
        building_id: selectedTenant.building_id,
        unit_id: selectedTenant.unit_id,
        year: selectedTenant.year,
        nature: selectedTenant.nature,
        type: selectedTenant.type,
        payment_status: "success",
        payment_mode: selectedPaymentMethod,
        payment_id: selectedPaymentMethod?.split("-")[0] || "manual",
        amount: selectedTenant.amount,
        month: selectedTenant.month,
        tenant_id: selectedTenant.tenant_id, // Add tenant_id
      };

      console.log("🚀 Submitting payload:", body);

      // Step 5: Make API call to save transaction
      const response = await APICall(
        "POST",
        paths.transaction.add,
        body,
        null,
        jwt
      );

      console.log("📥 API Response:", response);

      if (response.status === "success") {
        alert("Payment marked as successful!");
        onMarkAsPaid?.();
        onClose();
      } else {
        console.error("❌ Error submitting payment:", response);
        alert("Failed to mark payment as successful. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error during submission:", error);
      alert(
        "An error occurred while processing the payment. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const paymentMethods = [
    "manual-UPI",
    "manual-Cash",
    "manual-Cheque",
    "manual-NEFT",
    "manual-Others",
  ];

  // Show error if no tenant data
  if (!selectedTenant) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              No Tenant Data
            </h2>
            <p className="text-gray-600 mb-4">
              Unable to load tenant information. Please try again.
            </p>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  const tenantName =
    selectedTenant.first_name && selectedTenant.last_name
      ? `${selectedTenant.first_name} ${selectedTenant.last_name}`
      : selectedTenant.tenant_name || "Unknown Tenant";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Mark as Paid</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <IoCloseCircleOutline size={28} />
          </button>
        </div>

        {/* Tenant Info */}
        <div className="p-6 bg-blue-50 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {tenantName}
              </h3>
              <p className="text-gray-600">
                {selectedTenant.unit_name}, {selectedTenant.building_name}
              </p>
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold text-green-600">
                {selectedTenant.local_amount || `₹${selectedTenant.amount}`}
              </p>
              <p className="text-sm text-gray-500">
                {selectedTenant.month} {selectedTenant.year}
              </p>
            </div>
          </div>
        </div>

        <div className="p-6 space-y-6">
          {/* Payment Methods */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Select Payment Method
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {paymentMethods.map((method) => (
                <button
                  key={method}
                  type="button"
                  onClick={() => handlePaymentMethodChange(method)}
                  className={`p-3 rounded-lg border-2 font-medium transition-all ${
                    formData.paymentMethod === method
                      ? "border-blue-500 bg-blue-500 text-white"
                      : "border-gray-300 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-50"
                  }`}
                >
                  {method.split("-")[1]}
                </button>
              ))}
            </div>
          </div>

          {/* Description */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Add Description (Optional)
            </h3>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              placeholder="Add payment details, reference number, or any notes..."
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              rows={3}
            />
          </div>

          {/* File Upload */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Upload Receipt (Optional)
            </h3>
            {!formData.file ? (
              <div
                onClick={() => fileInputRef.current?.click()}
                className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-colors"
              >
                <IoAddSharp className="mx-auto text-4xl text-gray-400 mb-2" />
                <p className="text-gray-600 font-medium">Upload Receipt</p>
                <p className="text-sm text-gray-500">
                  PNG, JPG, JPEG (Max 5MB)
                </p>
              </div>
            ) : (
              <div className="relative border border-gray-300 rounded-lg p-4">
                <img
                  src={imagePreview}
                  alt="Receipt Preview"
                  onLoad={handleImageLoad}
                  className="w-full max-w-xs mx-auto rounded-lg"
                />
                <button
                  onClick={handleClearFile}
                  className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                >
                  <IoClose size={16} />
                </button>
              </div>
            )}
            <input
              type="file"
              ref={fileInputRef}
              multiple
              onChange={handleFileChange}
              accept="image/*"
              className="hidden"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 bg-gray-50">
          <div className="flex space-x-4">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-100 transition-colors"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={isLoading || !formData.paymentMethod}
              className={`flex-1 px-6 py-3 rounded-lg font-medium transition-colors ${
                isLoading || !formData.paymentMethod
                  ? "bg-gray-400 text-gray-300 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Processing...
                </div>
              ) : (
                "Submit Payment"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaidModal;
